import { ProjectTreeNode } from "./ProjectTreeUtil";

type ProjectTreeProps = {
  nodes: ProjectTreeNode[];
  selectedNode: ProjectTreeNode | undefined;
  indent?: boolean;
  onClick: (node: ProjectTreeNode) => void;
};
const ProjectTree = ({ nodes, selectedNode, indent, onClick }: ProjectTreeProps) => {
  let style = {};
  if (indent) {
    style = { marginLeft: 20 };
  }
  return (
    <div style={style}>
      {nodes.map((node) => {
        let className = "project-name";
        if (node.children.length > 0) {
          className = "project-folder";
        }
        if (selectedNode === node) {
          className += " selected";
        }
        return (
          <div>
            <div className={className} onClick={() => onClick(node)}>
              {node.text}
            </div>
            {node.showChildren && node.children.length > 0 && (
              <ProjectTree
                nodes={node.children}
                selectedNode={selectedNode}
                indent={true}
                onClick={onClick}
              ></ProjectTree>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProjectTree;
